var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSlipFall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2 5.5V2H9.3V4.59147L7.7 6.1L5 7L3.5 10V13H5.35V10.5L6.03958 9.12084L6.88205 10.3845L6.87988 10.386L8.27941 12.4993V12.5H8.27988H12.0001L15.5001 15.5L16.8001 14L12.5001 10.5H11.0422L11.0261 10.4758L13 8.50156H17.5002L17.5 6.60166L12.35 6.60156L10.2242 8.56883L9.20575 7.34666L11.2 5.5ZM7.95668 4.32834C7.95668 5.3381 7.1381 6.15668 6.12834 6.15668C5.11857 6.15668 4.3 5.3381 4.3 4.32834C4.3 3.31857 5.11857 2.5 6.12834 2.5C7.1381 2.5 7.95668 3.31857 7.95668 4.32834Z",
    fill: "#CCCFD1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 16,
    width: 16,
    height: 1.82834,
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlipFall);
export default __webpack_public_path__ + "static/media/icon-slip-fall.4ba6596d89d5685431da9213c0872ce4.svg";
export { ForwardRef as ReactComponent };